$(document).ready(function () {
    
$('.product-hero__big-items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    adaptiveHeight: true,
    asNavFor: '.product-hero__small-items',
    responsive: [{
        breakpoint: 768,
        settings: {
            slidesToShow: 1,
            slidesToScroll: 1
        }
    }, ]
});
$('.product-hero__small-items').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    vertical: true,
    asNavFor: '.product-hero__big-items',
    centerMode: false,
    focusOnSelect: true,
    arrows: false,
    infinite: true,
    responsive: [{
        breakpoint: 768,
        settings: {
            vertical: false,
            slidesToShow: 4,
            slidesToScroll: 1
        }
    }, ]
});

});





$(".collection-filters__variant-item-label").on("mouseenter", function () {

    $(this).parent(".collection-filters__color-item").find(".collection-filters__color-toltip").fadeIn(150);
});

$(".collection-filters__variant-item-label").on("mouseleave", function () {
    $(this).siblings(".collection-filters__color-toltip").fadeOut(150);
});


$(".product-hero__variant-item-label-color").on("mouseenter", function () {

    $(this).parent(".product-hero__color-item").find(".collection-filters__color-toltip").fadeIn(150);
});

$(".product-hero__variant-item-label-color").on("mouseleave", function () {
    $(this).parent(".product-hero__color-item").find(".collection-filters__color-toltip").fadeOut(150);
});



$(".header__mobi-left-search, .header__right-search").on("click", function () {

    $("body").addClass("open-searchBar");
    setTimeout(function() {
    $("#Search").focus();
}, 100);
})



function hideSearchBar() {
    $("body").removeClass("open-searchBar");
    $("#Search").val("");  
    $("#serch-field__result").hide()
}











// order traking js start here 

// $(document).ready(function () {
//   $('head').append(`
//     <style>
//       #widget .btn-ctn, #widget form {
//         width: 100% !important;
//         display: flex !important;
//         align-items: flex-start !important;
//         justify-content: flex-start !important;
//         flex-direction: column !important;
//         gap: 10px !important;
//       }
//     </style>
//   `);
// });





// order traking js end here 

















// ---------------hero start-------------

// window.addEventListener('load', function () {
//     document.querySelector('.cookie').classList.add('cookie-open');

// });
$('a[href*="#judgeme_product_reviews"]').on('click', function (e) {
    e.preventDefault();

    $('html, body').animate({
        scrollTop: $($(this).attr('href')).offset().top
    }, 1000, 'linear');
});


$(document).ready(function () {
    $('.video-text-block__video iframe, .comfort__right iframe').each(function () {
        var dataSrc = $(this).attr('data-src');
        if (dataSrc) {
            $(this).removeAttr('data-src').attr('src', dataSrc);
        }
    });
});



// $( document ).ready(function() {

//     let getUserCookie= localStorage.getItem("user_cookie");
//     if (getUserCookie) {
//         $(".cookie").removeClass("cookie-open");
//     }else{
//         $(".cookie").addClass("cookie-open");
//     }




//     $(".cookie__btn-delcine").on("click",function(e){
//         e.preventDefault()
//         localStorage.setItem("user_cookie","Cookie Delcine");
//         document.querySelector('.cookie').style.display = 'none';
//     })
//     $(".cookie__btn-allow").on("click",function(e){
//         e.preventDefault()
//         localStorage.setItem("user_cookie","Cookie Allow");
//         document.querySelector('.cookie').style.display = 'none';
//     })




// });




$(".hero__right").click(function () {
    var video = $(this).find("video").get(0);
    var icon_image = $(this).find(".hero__video-play-icon");
    if (video.paused) {
        $("video").each(function () {
            this.pause();
            $(".hero__video-play-icon").css("display", "block");
        });
        video.play();
        icon_image.css("display", "none");
    } else {
        video.pause();
        icon_image.css("display", "block");
    }
});
$(".hero__video-play-icon").click(function (e) {
    e.stopPropagation();
    var video = $(this).parent().find("video").get(0);
    var icon_image = $(this);
    if (video.paused) {
        $("video").each(function () {
            this.pause();
            $(".hero__video-play-icon").css("display", "block");
        });
        video.play();
        icon_image.css("display", "none");
    } else {
        video.pause();
        icon_image.css("display", "block");
    }
});




// ---------------hero end-------------





// -------------------sellers start------------------


if ($(Window).width() < 768) {
    $('.sellers__items').slick({
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }, ]
    });
}


$('.sellers__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});


$('.sellers__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});




$('.sellers__items').on('afterChange', function (event, slick, currentSlide) {
    if (currentSlide === 0) {
        $('.sellers__left-arrow').addClass('hidden');
    } else {
        $('.sellers__left-arrow').removeClass('hidden');
    }
    if (currentSlide === slick.slideCount - 1) {
        $('.sellers__right-arrow').addClass('hidden');
    } else {
        $('.sellers__right-arrow').removeClass('hidden');
    }
    // if ($(window).width() > 768) {
    //   if (currentSlide === slick.slideCount - 1) {
    //     $('.sellers__right-arrow').addClass('hidden');
    //   } else {
    //     $('.sellers__right-arrow').removeClass('hidden');
    //   }
    //   // console.log(currentSlide, "-", slick.slideCount - 3);
    // } else {
    //   if (currentSlide === slick.slideCount - 1) {
    //     $('.sellers__right-arrow').addClass('hidden');
    //   } else {
    //     $('.sellers__right-arrow').removeClass('hidden');
    //   }
    // }
});




// -------------------sellers end------------------




// -----------------choose start-----------------



if ($(Window).width() < 768) {
    $('.choose__items').slick({
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }, ]
    });
}



$('.choose__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.choose__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});



$('.choose__items').on('afterChange', function (event, slick, currentSlide) {
    if (currentSlide === 0) {
        $('.choose__left-arrow').addClass('hidden');
    } else {
        $('.choose__left-arrow').removeClass('hidden');
    }
    if (currentSlide === slick.slideCount - 1) {
        $('.choose__right-arrow').addClass('hidden');
    } else {
        $('.choose__right-arrow').removeClass('hidden');
    }
    // if ($(window).width() > 768) {
    //   if (currentSlide === slick.slideCount - 1) {
    //     $('.choose__right-arrow').addClass('hidden');
    //   } else {
    //     $('.choose__right-arrow').removeClass('hidden');
    //   }
    //   // console.log(currentSlide, "-", slick.slideCount - 3);
    // } else {
    //   if (currentSlide === slick.slideCount - 1) {
    //     $('.choose__right-arrow').addClass('hidden');
    //   } else {
    //     $('.choose__right-arrow').removeClass('hidden');
    //   }
    // }
});



// -----------------choose end-----------------



// -----------------review-card start-------------



if ($(Window).width() < 768) {
    $('.review-card__items').slick({
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }, ]
    });
}



$('.review-card__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.review-card__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});



// $('.review-card__items').on('afterChange', function (event, slick, currentSlide) {
//   if (currentSlide === 0) {
//     $('.review-card__left-arrow').addClass('hidden');
//   } else {
//     $('.review-card__left-arrow').removeClass('hidden');
//   }
//   if (currentSlide === slick.slideCount - 1) {
//     $('.review-card__right-arrow').addClass('hidden');
//   } else {
//     $('.review-card__right-arrow').removeClass('hidden');
//   }
//   // if ($(window).width() > 768) {
//   //   if (currentSlide === slick.slideCount - 1) {
//   //     $('.review-card__right-arrow').addClass('hidden');
//   //   } else {
//   //     $('.review-card__right-arrow').removeClass('hidden');
//   //   }
//   //   // console.log(currentSlide, "-", slick.slideCount - 3);
//   // } else {
//   //   if (currentSlide === slick.slideCount - 1) {
//   //     $('.review-card__right-arrow').addClass('hidden');
//   //   } else {
//   //     $('.review-card__right-arrow').removeClass('hidden');
//   //   }
//   // }
// });



//   $('.review-card__video-play-icon').on('click', function () {
//       var $icon = $(this);
//       var $video = $icon.closest('.review-card__item').find('.review-card__item-img video')[0];
//       // Pause all videos
//       $('.review-card__item-img video').each(function () {
//           this.pause();
//           this.currentTime = 0;
//           $(this).siblings('.review-card__video-play-icon').show();
//           // $(this).hide();
//       });
//       $video.play();
//       $icon.hide();
//       $($video).show();
//   });


//   $('.review-card__item-img video').on('click', function () {
//     var $icon = $(this);
//     // Pause all videos
//     $('.review-card__item-img video').each(function () {
//         this.pause();
//         this.currentTime = 0;
//         $(this).siblings('.review-card__video-play-icon').show();
//     });
//     $video.stop();
// });



$(".review-card__item-img").click(function () {
    var video = $(this).find("video").get(0);
    var icon_image = $(this).find(".review-card__video-play-icon");
    if (video.paused) {
        $("video").each(function () {
            this.pause();
            $(".review-card__video-play-icon").css("display", "block");
        });
        video.play();
        icon_image.css("display", "none");
    } else {
        video.pause();
        icon_image.css("display", "block");
    }
});
$(".review-card__video-play-icon").click(function (e) {
    e.stopPropagation();
    var video = $(this).parent().find("video").get(0);
    var icon_image = $(this);
    if (video.paused) {
        $("video").each(function () {
            this.pause();
            $(".review-card__video-play-icon").css("display", "block");
        });
        video.play();
        icon_image.css("display", "none");
    } else {
        video.pause();
        icon_image.css("display", "block");
    }
});





// -----------------review-card end-------------


// faq start


$(".faq__title , .product-hero__dropdown-title").click(function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass("active");
        $(this).next(".faq__content , .product-hero__dropdown-content").slideUp();
    } else {
        $(".faq__content , .product-hero__dropdown-content").slideUp();
        $(".faq__title , .product-hero__dropdown-title").removeClass("active");
        $(this).addClass("active");
        $(this).next(".faq__content , .product-hero__dropdown-content").slideDown();
    }
})


// faq end





// blog-home start



if ($(Window).width() < 768) {
    $('.blog-home__items').slick({
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }, ]
    });
}


$('.blog-home__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});


$('.blog-home__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});




$('.blog-home__items').on('afterChange', function (event, slick, currentSlide) {
    if (currentSlide === 0) {
        $('.blog-home__left-arrow').addClass('hidden');
    } else {
        $('.blog-home__left-arrow').removeClass('hidden');
    }
    if (currentSlide === slick.slideCount - 1) {
        $('.blog-home__right-arrow').addClass('hidden');
    } else {
        $('.blog-home__right-arrow').removeClass('hidden');
    }
    // if ($(window).width() > 768) {
    //   if (currentSlide === slick.slideCount - 1) {
    //     $('.blog-home__right-arrow').addClass('hidden');
    //   } else {
    //     $('.blog-home__right-arrow').removeClass('hidden');
    //   }
    //   // console.log(currentSlide, "-", slick.slideCount - 3);
    // } else {
    //   if (currentSlide === slick.slideCount - 1) {
    //     $('.blog-home__right-arrow').addClass('hidden');
    //   } else {
    //     $('.blog-home__right-arrow').removeClass('hidden');
    //   }
    // }
});


// blog-home end



// ---------------------footer start--------------------


if ($(Window).width() < 768) {
    $(".footer__center-item-content h3").click(function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass("active");
            $(this).next(".footer__center-list").slideUp();
        } else {
            $(".footer__center-list").slideUp();
            $(".footer__center-item-content h3").removeClass("active");
            $(this).addClass("active");
            $(this).next(".footer__center-list").slideDown();
        }
    })
}



// ---------------------footer end--------------------



// ---------------product-hero start-----------------



// $(window).on('load', function () {
//   $('.product-hero__big-items').slick({
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: false,
//     fade: false,
//     adaptiveHeight: true,
//     asNavFor: '.product-hero__small-items',
//     responsive: [{
//       breakpoint: 768,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }]
//   });

//   $('.product-hero__small-items').slick({
//     slidesToShow: 5,
//     slidesToScroll: 1,
//     vertical: true,
//     asNavFor: '.product-hero__big-items',
//     centerMode: false,
//     focusOnSelect: true,
//     arrows: false,
//     infinite: true,
//     responsive: [{
//       breakpoint: 768,
//       settings: {
//         vertical: false,
//         slidesToShow: 4,
//         slidesToScroll: 1
//       }
//     }]
//   });
// });

// $('.product-hero__small-items-left-arrow').click(function () {
//     $(this).parent().parent().find('.slick-slider').slick('slickPrev');
// });


  const $smallSlider = $('.product-hero__small-items');
  const $leftArrow = $('.product-hero__small-items-left-arrow');

  // Move to previous slide
  $leftArrow.click(function () {
    $smallSlider.slick('slickPrev');
  });

  // On slide change, check current index
  $smallSlider.on('afterChange', function (event, slick, currentSlide) {
    if (currentSlide > 1) {
      $leftArrow.addClass('active');
    } else {
      $leftArrow.removeClass('active');
    }
  });




$('.product-hero__small-items-right-arrow').click(function () {
    
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});

$('.product-hero__big-right-arrow').click(function () {
    
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});
  

$('.product-hero__big-left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});





// })

// ---------------product-hero end-----------------



// comfort start


// $(".comfort__right").click(function () {
//     var video = $(this).find("video").get(0);
//     var icon_image = $(this).find(".comfort__video-play-icon");
//     if (video.paused) {
//         $("video").each(function () {
//             this.pause();
//             $(".comfort__video-play-icon").css("display", "block");
//         });
//         video.play();
//         icon_image.css("display", "none");
//     } else {
//         video.pause();
//         icon_image.css("display", "block");
//     }
// });
$(".comfort__video-play-icon").click(function (e) {
    e.stopPropagation();
    var video = $(this).parent().find("video").get(0);
    var icon_image = $(this);
    if (video.paused) {
        $("video").each(function () {
            this.pause();
            $(".comfort__video-play-icon").css("display", "block");
        });
        video.play();
        icon_image.css("display", "none");
    } else {
        video.pause();
        icon_image.css("display", "block");
    }
});



// comfort end



// --------------benefits start-------------


if ($(Window).width() < 768) {
    $('.benefits__items').slick({
        rows: 2,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }, ]
    });
}




$('.benefits__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});


$('.benefits__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});


$('.benefits__items').on('afterChange', function (event, slick, currentSlide) {
    if (currentSlide === 0) {
        $('.benefits__left-arrow').addClass('hidden');
    } else {
        $('.benefits__left-arrow').removeClass('hidden');
    }
    if (currentSlide === slick.slideCount - 1) {
        $('.benefits__right-arrow').addClass('hidden');
    } else {
        $('.benefits__right-arrow').removeClass('hidden');
    }
    // if ($(window).width() > 768) {
    //   if (currentSlide === slick.slideCount - 1) {
    //     $('.benefits__right-arrow').addClass('hidden');
    //   } else {
    //     $('.benefits__right-arrow').removeClass('hidden');
    //   }
    //   // console.log(currentSlide, "-", slick.slideCount - 3);
    // } else {
    //   if (currentSlide === slick.slideCount - 1) {
    //     $('.benefits__right-arrow').addClass('hidden');
    //   } else {
    //     $('.benefits__right-arrow').removeClass('hidden');
    //   }
    // }
});




// --------------benefits end-------------



// popup start


// function openImageModal($this) {
//     var $src = $($this).siblings("img").attr("src");
//     $(".popup").fadeIn();
//     $(".popup__main-img img").attr("src", $src);
//     $(".popup__close").fadeIn(); // 
// }









var images = [];
var currentIndex = 0;

function openImageModal($this) {
  // Collect only the main product images (direct child of .product-hero__big-item)
  images = $(".product-hero__big-item > img").map(function () {
    return $(this).attr("src");
  }).get();

  // Find clicked image source
  var $src = $($this).siblings("img").attr("src");

  // Set current index
  currentIndex = images.indexOf($src);

  // Show modal
  $(".popup").fadeIn();
  $(".popup__main-img img").attr("src", $src);
}

// Close button
$(".popup__close").on("click", function () {
  $(".popup").fadeOut();
});

// Next arrow
$(".popup__arrow-right").on("click", function () {
  currentIndex = (currentIndex + 1) % images.length;
  $(".popup__main-img img").attr("src", images[currentIndex]);
});

// Prev arrow
$(".popup__arrow-left").on("click", function () {
  currentIndex = (currentIndex - 1 + images.length) % images.length;
  $(".popup__main-img img").attr("src", images[currentIndex]);
});
















$(".popup__close , .overlay-bg, .size-guide__crose").click(function () {
    $(".popup").fadeOut();
    $(".popup__close").fadeOut();
    $("body").removeClass('active-popup');
    $(".size-guide").fadeOut();
    $("body").removeClass("open-searchBar");

});

function open_size_guideModal() {
    $(".size-guide").fadeIn();
    $("body").addClass('active-popup');
}






$(".product-hero__big-item-zoom").on('click', function () {
    $("body").addClass('active-popup');
})


// popup end



// ---------------------cart start-----------------

// $('.cart__product-add-items').slick({
//     dots: true,
//     arrows: false,
//     infinite: true,
//     speed: 300,
//     slidesToShow: 1,
//     adaptiveHeight: true
// });



$(".header__right-cart").on('click', function () {
    $("body").addClass('cart-open');
})


$(".cart__top-cross-img , .overlay-bg").on('click', function () {
    $("body").removeClass('cart-open');
})


// ---------------------cart end-----------------





// -------------------collection-shop start----------------


if ($(Window).width() < 768) {
    $(".collection-shop__title").click(function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass("active");
            $(this).next(".collection-shop__content").slideUp();
        } else {
            $(".collection-shop__content").slideUp();
            $(".collection-shop__title").removeClass("active");
            $(this).addClass("active");
            $(this).next(".collection-shop__content").slideDown();
        }
    })
}
// -------------------collection-shop end----------------




// -------------------------collection-filters start--------------------


if ($(window).width() < 768) {
    $(".collection-filters__filter-title").click(function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass("active");
            $(".collection-filters__filter").slideUp().removeClass('active');
        } else {
            // Slide up the sort dropdown when filters are shown
            $(".collection-filters__sort").slideUp();
            $(".collection-filters__sort-wrap").removeClass("active");

            $(".collection-filters__filter").slideDown().addClass('active');
            $(this).addClass("active");
        }
    });
}



$(".collection-filters__item-title").click(function () {
    console.log($(this))
    if ($(this).hasClass('active')) {
        console.log('hi')
        $(this).removeClass("active");
        $(this).next(".collection-filters__item-content").slideUp();
    } else {
        // $(".collection-filters__item-content").slideUp();
        // $(".collection-filters__item-title").removeClass("active");
        $(this).addClass("active");
        $(this).next(".collection-filters__item-content").slideDown();
    }
})




$(".collection-filters__sort-wrap").click(function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass("active");
        $(".collection-filters__sort").slideUp();
    } else {
        // Slide up the filters dropdown when sort is shown
        $(".collection-filters__filter").slideUp().removeClass('active');
        $(".collection-filters__filter-title").removeClass("active");

        $(".collection-filters__sort").slideDown();
        $(this).addClass("active");
    }
});



$(".collection-filters__select").click(function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass("active");
        $(".collection-filters__top-wrap ul").slideUp();
    } else {
        $(".collection-filters__top-wrap ul").slideDown();
        $(this).addClass("active");
    }
})




// -------------------------collection-filters end--------------------





// cookie start





// // // // Wait for the page to fully load
// window.addEventListener('load', function () {
//     // Add the 'cookie-open' class to the .cookie element
//     document.querySelector('.cookie').classList.add('cookie-open');

//     // Select all <a> elements inside .cookie__btn
//     const cookieBtns = document.querySelectorAll('.cookie__btn a');

//     // Add a click event listener to each <a> tag
//     cookieBtns.forEach(function (btn) {
//         btn.addEventListener('click', function () {
//             // Hide the .cookie element by setting display to 'none'
//             document.querySelector('.cookie').style.display = 'none';
//         });
//     });
// });



// // cookie end





// menu start





// mobile menu js 

$(".header__mobi-left-menu").on("click", function () {
    $(this).toggleClass("active");
    $(".header__mobi-left-text-close").toggleClass("active");
    $(".header__mobi-left-text-open").toggleClass("active");
    $(".header__mobi-menu").toggleClass('active');
    // $(".header__menu-drawer").toggleClass("active");
    $("body").toggleClass("mobile__menu-open");
})


// $('.header__menu-drawer-sub-icon , .header__menu-drawer-sub-sub-menu li a').click(function (e) {
//     e.preventDefault();
//     $(this).toggleClass('active');
//     $(this).next(".header__menu-drawer-sub-menu").slideToggle(400);
//     $(this).next(".header__menu-drawer-sub-sub-menu-sub").slideToggle(400);

// });


$('.header__menu-drawer-sub-icon, .header__menu-drawer-sub-sub-menu > li > a').click(function (e) {
    e.preventDefault();
    $(this).toggleClass('active');
    $(this).next(".header__menu-drawer-sub-menu").slideToggle(400);
    $(this).next('.header__menu-drawer-sub-sub-menu-sub').slideToggle(400);

});




$('.header__menu-drawer-sub-child').click(function (e) {
    e.preventDefault();
    $(this).next(".header__menu-drawer-sub-child-wrap").slideToggle(400);

});





$(".header__mega-menu-list-icon").hover(
    function () {
        $(this).addClass("active");
        $(".header__mega-product").addClass("active");
    },
    function () {
        $(this).removeClass("active");
        $(".header__mega-product").removeClass("active");
    }
);


// menu end



// scroll-behavior smooth


$('a[href*="#faq"]').on('click', function (e) {
    e.preventDefault();

    $('html, body').animate({
        scrollTop: $($(this).attr('href')).offset().top
    }, 1000, 'linear');
});


$(window).on('scroll', function () {
    const currentScroll = $(this).scrollTop();
    const $body = $('body');

    if (currentScroll >= 35) {
        $body.addClass('header-sticky');
    } else {
        $body.removeClass('header-sticky');
    }
});